module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-iltempo.0e98c3361e37bb054e53708e6e9f6025.png";